/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 61);
/******/ })
/************************************************************************/
/******/ ({

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

__webpack_require__(62);

__webpack_require__(63);

/* global AFRAME THREE TWEEN PROJECT_VERSION PROJECT_NAME PROJECT_ISSUE_URL */
/**
 * 1. app styles will be extraxted to style/app-theme.css
 *    and not included in final bundle of this entry point!
 */
var appConfig = __webpack_require__(64);

if (process.env.NODE_ENV !== 'production' && typeof AFRAME !== 'undefined') {
  var info = AFRAME.utils.debug("webxr-webpack-boilerplate" + ':info');
  info('Looks like we are in development mode!');
  info('Version: ' + "0.9.10" + '-dev');
  info('report issues: ' + "https://github.com/mkungla/webxr-webpack-boilerplate/issues");
  info('A-Frame Version: ' + AFRAME.version);
  info('three.js Version: r' + THREE.REVISION);
  info('including TWEEN: ' + TWEEN._nextId);
  console.dir(appConfig);
}

// ServiceWorker is a progressive technology. Ignore unsupported browsers
if ('serviceWorker' in navigator) {
  //   console.log('CLIENT: service worker registration in progress.')
  //   navigator.serviceWorker.register('/service-worker.js').then(function () {
  //     console.log('CLIENT: service worker registration complete.')
  //   }, function () {
  //     console.log('CLIENT: service worker registration failure.')
  //   })
  // } else {
  //   console.log('CLIENT: service worker is not supported.')
}

(function () {

  window.addEventListener("load", function load(event) {
    var aScene = document.querySelector("a-scene");
    var landingDiv = document.querySelector("#background-landing");
    var progressDiv = document.querySelector("#progressDiv");
    var vrnBtn = document.querySelector("#enter-vr");
    var gearvrBtn = document.querySelector("#enter-gearvr");
    var music = document.querySelector("#music");
    var gearvrDevice = AFRAME.utils.device.isGearVR();
    var mobileDevice = AFRAME.utils.device.isMobile();
    var desktopDevice = !AFRAME.utils.device.checkHeadsetConnected();
    var ViveRiftDevice = AFRAME.utils.device.isMobile() && AFRAME.utils.device.checkHeadsetConnected();

    window.removeEventListener("load", load, false); //remove listener, no longer needed

    function onSceneLoaded() {

      if (progressDiv) {
        progressDiv.remove();
      }

      if (vrnBtn) {
        vrnBtn.style.display = "block";
        vrnBtn.addEventListener("click", entervrhandler);
      }

      if (gearvrBtn) {
        gearvrBtn.style.display = "block";
        gearvrBtn.addEventListener("click", entergearvrhandler);
      }

      function entervrhandler() {
        landingDiv.remove();
        aScene.style.display = "block";
        playBackgroundMusic();
        timeoutIntro();
      }

      function entergearvrhandler() {
        landingDiv.style.display = "none";
        aScene.style.display = "block";
        // playBackgroundMusic();          
        document.querySelector('a-scene').enterVR();
        timeoutIntro();
      }

      aScene.addEventListener('enter-vr', function () {
        if (gearvrDevice) {
          playBackgroundMusic();
        }
      });

      function playBackgroundMusic() {
        music.components.sound.playSound();
      }

      var introScreen = null;
      var introScreenCardboard = document.getElementById("intro-screen-cardboard");
      var introScreenGearVR = document.getElementById("intro-screen-gearvr");
      var timeout;
      function timeoutIntro() {
        console.log('setTimeout');
        timeout = setTimeout(function () {
          if (introScreen) {
            console.log('close Intro after 20s');
            introScreen.emit("closeintro");
          }
        }, 20000);
      }

      function stopTimeoutIntro() {
        console.log('clearTimeout');
        clearTimeout(timeout);
      }

      if (introScreenCardboard) {
        introScreen = introScreenCardboard;
        introScreenCardboard.addEventListener('click', function () {
          this.emit("closeintro");
          stopTimeoutIntro();
        });
      }

      if (introScreenGearVR) {
        introScreen = introScreenGearVR;
        introScreenGearVR.addEventListener('click', function () {
          this.emit("closeintro");
          stopTimeoutIntro();
        });
      }

      /*
            var showucaasbtn = document.getElementById("showucaasbtn");
            var ucaascontainer = document.getElementById("ucaascontainer");
            var videoucaas = document.getElementById("avid_ucaas");
      
            showucaasbtn.addEventListener('click', function () {
              ucaascontainer.setAttribute('visible', 'true');
              ucaascontainer.setAttribute('scale', '1 1 1');
              videoucaas.play();
            }); 
      */
      //////////////////////////// DEMOS
      var deviceDemo = document.getElementById("chimedevicedemo");
      // var deviceDemoHide = document.getElementById("chimedevicedemohide");

      var capacityDemo = document.getElementById("chimecapacitydemo");
      // var capacityDemoHide = document.getElementById("chimecapacitydemohide");

      var smartwanDemo = document.getElementById("smartwandemo");
      // var smartwanDemoHide = document.getElementById("smartwandemohide");

      var skillsDemo = document.getElementById("contactcenterskillsdemo");
      // var skillsDemoHide = document.getElementById("contactcenterskillsdemohide");

      var issuesDemo = document.getElementById("contactcenterissuesdemo");
      // var issuesDemoHide = document.getElementById("contactcenterissuesdemohide");

      var retailDemo = document.getElementById("reachretaildemo");
      // var retailDemoHide = document.getElementById("reachretaildemohide");

      var realestateDemo = document.getElementById("reachrealestatedemo");
      // var realestateDemoHide = document.getElementById("reachrealestatedemohide");

      window.demochime1 = function () {
        //        capacityDemoHide.emit("hidedemo");        
        deviceDemo.emit("chime-device-demo-play");
        ga('send', {
          hitType: 'event',
          eventCategory: 'Amazon Chime',
          eventAction: 'play',
          eventLabel: 'Demo - Access Across Devices'
        });
      };
      window.demochime2 = function () {
        //        deviceDemoHide.emit("hidedemo");        
        capacityDemo.emit("chime-capacity-demo-play");
        ga('send', {
          hitType: 'event',
          eventCategory: 'Amazon Chime',
          eventAction: 'play',
          eventLabel: 'Demo - High Capacity Collaboration'
        });
      };
      window.bookmarkchime = function () {
        ga('send', {
          hitType: 'event',
          eventCategory: 'Amazon Chime',
          eventAction: 'check',
          eventLabel: 'Product Bookmarked'
        });
      };

      window.democontactcenter1 = function () {
        //          issuesDemoHide.emit("hidedemo");
        skillsDemo.emit("contactcenter-skills-demo-play");
        ga('send', {
          hitType: 'event',
          eventCategory: 'Contact Center',
          eventAction: 'play',
          eventLabel: 'Demo - ACD & Skill-based Routing'
        });
      };
      window.democontactcenter2 = function () {
        //          skillsDemoHide.emit("hidedemo");
        issuesDemo.emit("contactcenter-issues-demo-play");
        ga('send', {
          hitType: 'event',
          eventCategory: 'Contact Center',
          eventAction: 'play',
          eventLabel: 'Demo - Real-time Sentiment Analysis'
        });
      };
      window.bookmarkcontactcenter = function () {
        ga('send', {
          hitType: 'event',
          eventCategory: 'Contact Center',
          eventAction: 'check',
          eventLabel: 'Product Bookmarked'
        });
      };

      window.demosmartwan = function () {
        smartwanDemo.emit("smartwan-demo-play");
        ga('send', {
          hitType: 'event',
          eventCategory: 'SmartWan',
          eventAction: 'play',
          eventLabel: 'Demo - Voice Prioritization/QoE'
        });
      };
      window.bookmarksmartwan = function () {
        ga('send', {
          hitType: 'event',
          eventCategory: 'SmartWan',
          eventAction: 'check',
          eventLabel: 'Product Bookmarked'
        });
      };

      window.demovonagereach1 = function () {
        //          realestateDemoHide.emit("hidedemo");
        retailDemo.emit("reach-retail-demo-play");
        ga('send', {
          hitType: 'event',
          eventCategory: 'Vonage Reach',
          eventAction: 'play',
          eventLabel: 'Demo - Case Study: Retail'
        });
      };
      window.demovonagereach2 = function () {
        //          retailDemoHide.emit("hidedemo");
        realestateDemo.emit("reach-realestate-demo-play");
        ga('send', {
          hitType: 'event',
          eventCategory: 'Vonage Reach',
          eventAction: 'play',
          eventLabel: 'Demo - Case Study: Real Estate'
        });
      };
      window.bookmarkvonagereach = function () {
        ga('send', {
          hitType: 'event',
          eventCategory: 'Vonage Reach',
          eventAction: 'check',
          eventLabel: 'Product Bookmarked'
        });
      };

      window.videocrm = function () {
        ga('send', {
          hitType: 'event',
          eventCategory: 'CRM Integrations',
          eventAction: 'play',
          eventLabel: 'CRM Video Watched'
        });
      };
      window.bookmarkcrm = function () {
        ga('send', {
          hitType: 'event',
          eventCategory: 'CRM Integrations',
          eventAction: 'check',
          eventLabel: 'Product Bookmarked'
        });
      };

      window.videosip = function () {
        ga('send', {
          hitType: 'event',
          eventCategory: 'SIP Trunking',
          eventAction: 'play',
          eventLabel: 'SIP Trunking Video Watched'
        });
      };
      window.bookmarksip = function () {
        ga('send', {
          hitType: 'event',
          eventCategory: 'SIP Trunking',
          eventAction: 'check',
          eventLabel: 'Product Bookmarked'
        });
      };

      window.videoucaas = function () {
        ga('send', {
          hitType: 'event',
          eventCategory: 'UCaaS & CPaaS',
          eventAction: 'play',
          eventLabel: 'UCaaS & CPaaS Video Watched'
        });
      };
      window.bookmarkucaas = function () {
        ga('send', {
          hitType: 'event',
          eventCategory: 'UCaaS & CPaaS',
          eventAction: 'check',
          eventLabel: 'Product Bookmarked'
        });
      };

      window.opentrunk = function () {
        ga('send', {
          hitType: 'event',
          eventCategory: 'Tradeshow Only',
          eventAction: 'open',
          eventLabel: 'Treasure Trunk'
        });
      };

      //////////////////////////// END DEMOS

      document.addEventListener("GARREADY", function (e) {
        if (gearvrDevice) {
          console.log('--------------------------AFRAME.utils.device.isGearVR ()');
          e.detail.setCustomVariable('GearVR');
        }
        if (mobileDevice) {
          console.log('--------------------------AFRAME.utils.device.isMobile ()');
          e.detail.setCustomVariable('Cardboard / Mobile');
        }
        if (ViveRiftDevice) {
          console.log('--------------------------AFRAME.utils.device.isMobile() && AFRAME.utils.device.checkHeadsetConnected()');
          e.detail.setCustomVariable('Oculus Rift / HTC Vive');
        }
        if (desktopDevice) {
          console.log('--------------------------Desktop');
          e.detail.setCustomVariable('Desktop');
        }
      });
    };
    if (aScene) {
      aScene.hasLoaded ? onSceneLoaded() : aScene.addEventListener("loaded", onSceneLoaded);
    }
  }, false);
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var base_url = "https://backend-vonagevrcpev2.herokuapp.com";

$(document).ready(function () {
  console.log("jQuery loaded");
  // jQuery methods go here...

  if (window.location.pathname.includes("gearvr")) {
    $('#enter-gearvr').addClass('disabled');
    $('#name').keyup(function () {
      if ($(this).val().length != 0) $('#enter-gearvr').removeClass('disabled');else $('#enter-gearvr').addClass('disabled');
    });
  }

  $("#submit-button, #enter-gearvr").click(function () {
    console.log("SUBMITTED");
    var name = $('#name').val();
    var company = $('#company').val();
    var email = $('#email').val();
    if (name === "" && company === "" && email === "") {
      name = $('#name2').val();
      company = $('#company2').val();
      email = $('#email2').val();
    }
    var currentP;
    var chnlMgr = $('#chnlMgr').val();
    if (chnlMgr !== "") {
      var currentP = true;
    } else {
      currentP = false;
    }
    var typeP = $('#typeP').val();
    var companySize = $('#companySize').val();
    var vertical = $('#vertical').val();

    if (window.location.pathname.includes("gearvr")) {
      email = "gearvrcustomer@vonage.com" + Math.random();
    }

    console.log(name, company, email, currentP, chnlMgr, typeP, companySize, vertical);

    storeUserFormData(name, company, email, currentP, chnlMgr, typeP, companySize, vertical).then(function (user) {
      console.log("User Created! ", user);
    });
  });
});

var storeUserFormData = function storeUserFormData(name, company, email, currentP, chnlMgr, typeP, companySize, vertical) {
  var user = {
    "name": name,
    "company": company,
    "email": email,
    "currentP": currentP,
    "chnlMgr": chnlMgr,
    "typeP": typeP,
    "companySize": companySize,
    "vertical": vertical
  };

  localStorage.setItem('active_user', JSON.stringify(user));

  return new Promise(function (resolve, reject) {
    $.ajax({
      url: base_url + '/user',
      type: 'GET',
      dataType: 'jsonp',
      data: user,
      success: function success(data) {
        resolve(data);
      },
      error: function error(err) {
        console.log('Failed!', err);
        resolve(err);
      },
      complete: function complete(xmlHttp) {
        // xmlHttp is a XMLHttpRquest object
        //alert(xmlHttp.status);
        if (xmlHttp.code != 200) {
          if (!window.location.pathname.includes("gearvr")) {
            top.location.href = 'cardboard.html';
          }
        }
      }
    });
  });
};

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 64:
/***/ (function(module, exports) {

module.exports = {"project":{"name":"Vonage VR CPE Version 2","version":"1.0.1","description":"","author":"Roland Dubois <rdub80@gmail.com> (https://github.com/rdub80)","license":"MIT","repository":{"type":"git","url":"https://github.com/rdub80/vonagevrcpev2.git"},"bugs":{"url":"https://github.com/rdub80/vonagevrcpev2/issues"},"homepage":"https://github.com/rdub80/vonagevrcpev2#readme","keywords":["webxr-boilerplate","webvr","webxr","boilerplate-application","starter-kit","aframe","aframevr","aframexr","aframe-vr","aframe-boilerplate","webpack","webpack-boilerplate","sass","pwa","service-workers"]},"app":{"name":"Vonage VR CPE","themecolor":"#ee295f","mstilecolor":"#24caff"}}

/***/ })

/******/ });


// WEBPACK FOOTER //
// js/app.js